const UAT_URL = 'https://uat-api.resinsmart.ai';
const APP_URL = 'https://api.resinsmart.ai';
const DEV_URL = 'https://dev-api.resinsmart.ai';
const LOCAL_URL = 'https://local-api.resinsmart.ai';
const getBaseUrl = () => {
    const envApiBase = import.meta.env.VITE_API_BASE_URL;
    if (envApiBase)
        return envApiBase;
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prMatch = hostname.match(/^(\d+)\.(dev)\./);
    if (prMatch)
        return `https://${prMatch[1]}.dev-api.resinsmart.ai`;
    if (hostname.includes("uat"))
        return UAT_URL;
    if (hostname.includes("app"))
        return APP_URL;
    if (hostname.includes("dev"))
        return DEV_URL;
    if (hostname.includes("local.resinsmart.ai") || hostname === "localhost")
        return DEV_URL;
    return DEV_URL;
};
export default getBaseUrl;
//# sourceMappingURL=baseUrl.js.map